module.exports = __webpack_public_path__ + "img/bottom_shade.dc1c6f71.png";